export default {
    SEA: "sea",
    DATA: "data",
    CITY: "city",
    THINGS: "things",
    ALL:"all"
}